import {
  ArrowDown,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Calculator,
  CalendarDays,
  Camera,
  Check,
  ChevronDown,
  CircleCheck,
  CircleHelp,
  CircleX,
  Download,
  Ellipsis,
  EllipsisVertical,
  Funnel,
  GripVertical,
  Info,
  Pencil,
  Plus,
  Printer,
  RefreshCw,
  RotateCcw,
  Search,
  Send,
  Square,
  Trash2,
  TriangleAlert,
  Upload,
  X,
} from "lucide-react";

const ICONS = {
  angle: ChevronDown,
  calendar: CalendarDays,
  check: Square,
  "check-active": Check,
  close: X,
  delete: Trash2,
  download: Download,
  edit: Pencil,
  ellipsis: Ellipsis,
  error: CircleX,
  filter: Funnel,
  information: Info,
  more: EllipsisVertical,
  plus: Plus,
  print: Printer,
  reset: RotateCcw,
  search: Search,
  success: CircleCheck,
  upload: Upload,
  warning: TriangleAlert,
  refresh: RefreshCw,
  send: Send,
  camera: Camera,
  calculator: Calculator,
  grip: GripVertical,
  help: CircleHelp,
  checkmark: Check,
  "sort-up": ArrowUp,
  "sort-down": ArrowDown,
  "sort-both": ArrowUpDown,
  "arrow-right": ArrowRight,
};

const SIZE_ALIASES = {
  16: "xsmall",
  20: "small",
  24: "medium",
  32: "large",
  40: "xlarge",
};

export default function SystemIcon({
  name,
  size = "medium",
  direction,
  className = "",
}) {
  const Icon = ICONS[name];
  if (!Icon) return null;

  const normalizedSize = SIZE_ALIASES[size] || size;
  const classes = [
    "ds-system-icon",
    `ds-system-icon--${normalizedSize}`,
    direction && `ds-system-icon--${direction}`,
    className,
  ].filter(Boolean).join(" ");

  return (
    <span className={classes} aria-hidden="true">
      <Icon width="100%" height="100%" />
    </span>
  );
}
